namespace GeniuzPOS.InitialData {
    export namespace PsDiscCouponTypeShopService {
        export const baseUrl = 'InitialData/PsDiscCouponTypeShop';

        export declare function Create(request: Serenity.SaveRequest<PsDiscCouponTypeShopRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsDiscCouponTypeShopRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsDiscCouponTypeShopRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsDiscCouponTypeShopRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsDiscCouponTypeShop/Create",
            Update = "InitialData/PsDiscCouponTypeShop/Update",
            Delete = "InitialData/PsDiscCouponTypeShop/Delete",
            Retrieve = "InitialData/PsDiscCouponTypeShop/Retrieve",
            List = "InitialData/PsDiscCouponTypeShop/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsDiscCouponTypeShopService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
